import axios, { AxiosResponse } from 'axios';

export const getPrintForm = (
    apiUrl: string,
    params: Record<string, any> = {},
    isPost = false,
    tokenStr?: string
) => {
    const headers: Record<string, string> = {
        Accept: 'application/pdf',
    };

    if (tokenStr) {
        headers.Authorization = tokenStr;
    }

    if (isPost) {
        return axios.post(apiUrl, null, {
            params: {
                ...params,
                print: true,
            },
            responseType: 'arraybuffer',
            headers,
        });
    }

    return axios.get(apiUrl, {
        params: {
            ...params,
            print: true,
        },
        responseType: 'arraybuffer',
        headers,
    });
};
